/* ---------------------------------------------------------------------------
   pm-free-gifts.js — 2026-09-17

   Offre « Buy 2, get 5 free gifts » : des que le panier contient le nombre requis
   d'articles eligibles (rouleaux, rouleaux enfants, cubes), les cadeaux definis dans
   le reglage de theme « Free Gifts (Buy 2) » sont ajoutes, un exemplaire chacun. Des
   que le panier repasse sous le seuil, ils sont retires.

   Le script ne decide RIEN lui-meme : il lit /cart?view=pm-gifts, un gabarit Liquid
   qui connait les collections et le reglage, et renvoie
     { eligible, min, gifts:[{product_id,variant_id,available}], lines:[{key,...,quantity}] }.
   /cart.js ne donne ni collections ni reglages, d'ou ce detour. Une seule regle
   d'eligibilite, partagee avec le tiroir (templates/cart.ajax.liquid).

   Invariants :
   - sous le seuil, aucun cadeau ne reste : un panier de cadeaux seuls serait une
     commande a 0 $ qui demande pourtant une expedition ;
   - au-dessus, chaque cadeau est present exactement une fois. La cliente qui en
     retire un le voit revenir (meme decision que pour l'ancien Mystery Gift) ;
   - un cadeau indisponible est ignore plutot que de faire echouer tout l'ajout.

   Ciblage des lignes par `key`, jamais par index : les index bougent des qu'une
   ligne est scindee ou regroupee (cf. pm-cart-merge.js).
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var busy = false;
  var failures = 0;
  var MAX_FAILURES = 3; // au-dela on s'arrete : inutile de marteler une erreur

  function repaint() {
    // update() et non load() : load() est garde par un isLoaded et ne repeint pas.
    if (window.theme && theme.ajaxCart) {
      if (typeof theme.ajaxCart.update === 'function') theme.ajaxCart.update();
      else if (typeof theme.ajaxCart.load === 'function') theme.ajaxCart.load();
    }
  }

  function post(url, body) {
    busy = true;
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        busy = false;
        if (!r.ok) { failures++; return; }
        failures = 0;
        // Le repaint rediffuse afterCartLoad : second passage dans reconcile(),
        // sans effet puisque le panier est alors conforme. C'est ce qui arrete la boucle.
        repaint();
      })
      .catch(function () { busy = false; failures++; });
  }

  function reconcile(state) {
    if (busy || failures >= MAX_FAILURES) return;
    if (!state || !state.gifts || !state.gifts.length) return;

    var lines = state.lines || [];
    var updates = {};
    var i;

    if (state.eligible < state.min) {
      if (!lines.length) return;
      for (i = 0; i < lines.length; i++) updates[lines[i].key] = 0;
      post('/cart/update.js', { updates: updates });
      return;
    }

    // Au-dessus du seuil : ajouter ce qui manque...
    var have = {};
    for (i = 0; i < lines.length; i++) have[lines[i].product_id] = true;
    var missing = [];
    for (i = 0; i < state.gifts.length; i++) {
      var g = state.gifts[i];
      if (!have[g.product_id] && g.available) missing.push({ id: g.variant_id, quantity: 1 });
    }
    if (missing.length) {
      post('/cart/add.js', { items: missing });
      return;
    }

    // ...puis ramener a 1 toute quantite differente.
    var dirty = false;
    for (i = 0; i < lines.length; i++) {
      if (lines[i].quantity !== 1) { updates[lines[i].key] = 1; dirty = true; }
    }
    if (dirty) post('/cart/update.js', { updates: updates });
  }

  function check() {
    if (busy || failures >= MAX_FAILURES) return;
    fetch('/cart?view=pm-gifts&t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { reconcile(JSON.parse(t)); })
      .catch(function () {});
  }

  // 2026-10-09 (panier lent) : les deux signaux ci-dessous partent ensemble a chaque rechargement
  // du tiroir, et check() etait lance deux fois (2 lectures de /cart?view=pm-gifts). On les
  // regroupe : un seul passage par rechargement.
  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(check, 30); }
  if (window.jQuery) jQuery('body').on('ajaxCart.afterCartLoad', schedule);
  document.addEventListener('dbtfy:cartLoaded', schedule);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
